import INSPECTION_DETAIL_ACTIONS from '../../constants/actions/inspection';

class InspectionDetailAction {
    static loadInspection = (userIdentity, requestId) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL,
        payload: {
            userIdentity,
            requestId
        }
    });

    static loadInspectionOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_OK,
        payload
    });

    static loadInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_ERROR,
        payload
    });

    static loadState = (userIdentity, requestId) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_STATE,
        payload: {
            userIdentity,
            requestId
        }
    });

    static loadStateOk = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_STATE_OK,
        payload
    });

    static loadStateError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_STATE_ERROR,
        payload
    });

    static loadCustomerOk = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_CUSTOMER_OK,
        payload
    });

    static loadCustomerError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_CUSTOMER_ERROR,
        payload
    });

    static loadInfoInspectionOk = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_OK,
        payload
    });

    static loadInfoInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_ERROR,
        payload
    });

    static loadPictures = (userIdentity, requestId) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_PICTURES,
        payload: {
            userIdentity,
            requestId
        }
    });

    static loadPicturesOK = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_PICTURES_OK,
        payload
    });

    static loadPicturesError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_PICTURES_ERROR,
        payload
    });

    static loadPicturesObserveds = (userIdentity, requestId) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_PICTURES_OBSERVEDS,
        payload: {
            userIdentity,
            requestId
        }
    });

    static loadPicturesObservedsOk = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_PICTURES_OBSERVEDS_OK,
        payload
    });

    static loadPicturesObservedsError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_PICTURES_OBSERVEDS_ERROR,
        payload
    });

    static loadPicturesDamages = (userIdentity, requestId) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_DAMAGES,
        payload: {
            userIdentity,
            requestId
        }
    });

    static loadPicturesDamagesOK = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_DAMAGES_OK,
        payload
    });

    static loadPicturesDamagesError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_DAMAGES_ERROR,
        payload
    });

    static loadPolicy = (policyNumber) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_POLICY,
        payload: {
            policyNumber
        }
    });

    static loadPolicyOK = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_POLICY_OK,
        payload
    });

    static loadPolicyError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_POLICY_ERROR,
        payload
    });

    static registerPicturesObserved = (userIdentity, requestId, modelReturn) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_REGISTER_PICTURE_OBSERVED,
        payload: {
            userIdentity,
            requestId,
            modelReturn
        }
    });

    static registerPicturesObservedOk = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_REGISTER_PICTURE_OBSERVED_OK,
        payload
    });

    static registerPicturesObservedError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_REGISTER_PICTURE_OBSERVED_ERROR,
        payload
    });

    static loadAccesories = (userIdentity, requestId) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_ACCESORIES,
        payload: {
            userIdentity,
            requestId
        }
    });

    static loadAccesoriesOk = payload => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_ACCESORIES_OK,
        payload
    });

    static loadAccesoriesError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_ACCESORIES_ERROR,
        payload
    });

    static approvedInspection = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED
    });

    static approvedInspectionOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED_OK,
        payload
    });

    static approvedInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED_ERROR,
        payload
    });

    static approvedInspectionReset = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED_RESET,
    });

    //-----------------------------------------------------------------------------------

    static returnToApproved = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_APPROVED
    });

    static returnToApprovedOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_APPROVED_OK,
        payload
    });

    static returnToApprovedError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_APPROVED_ERROR,
        payload
    });

    static returnToInPerson = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_IN_PERSON
    });

    static returnToInPersonOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_IN_PERSON_OK,
        payload
    });

    static returnToInPersonError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_IN_PERSON_ERROR,
        payload
    });

    static changeInPersonToCreate = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_CREATE,
    });

    static changeInPersonToCreateOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_CREATE_OK,
        payload
    });

    static changeInPersonToCreateError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_CREATE_ERROR,
        payload
    });

    //Actions para changeInPersonToReturn

    static changeInPersonToReturn = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_RETURN,
    });

    static changeInPersonToReturnOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_RETURN_OK,
        payload
    });

    static changeInPersonToReturnError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_RETURN_ERROR,
        payload
    });


    static updateVehiclePlateInspection = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_UPDATE_VEHICLE_PLATE,
        payload
    });

    static updateVehiclePlateInspectionOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_OK,
        payload
    });

    static updateVehiclePlateInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_ERROR,
        payload
    });

    static removeInspections = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REMOVE_INSPECTIONS,
        payload
    });

    static removeInspectionsOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REMOVE_INSPECTIONS_OK,
        payload
    });

    static removeInspectionsError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REMOVE_INSPECTIONS_ERROR,
        payload
    });

    //-----------------------------------------------------------------------------------

    static presencialInspection = (userIdentity, requestId, body) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL,
        payload: {
            userIdentity,
            requestId,
            body
        }
    });

    static presencialInspectionOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_OK,
        payload: payload.response
    });

    static presencialInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_ERROR,
        payload
    });

    static presencialInspectionReset = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_RESET,
    });

    static rejectedInspection = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED,
        payload
    });

    static rejectedInspectionOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED_OK,
        payload
    });

    static rejectedInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED_ERROR,
        payload
    });

    static rejectedInspectionReset = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED_RESET,
    });


    static deriveInspection = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE,
        payload
    });

    static deriveInspectionOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE_OK,
        payload
    });

    static deriveInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE_ERROR,
        payload
    });

    static deriveInspectionReset = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE_RESET,
    });

    static resetValues = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RESET_VALUES,
        payload
    });

    static returnInspection = (itemsObserved) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN,
        payload: {
            itemsObserved
        }
    });

    static returnInspectionOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_OK,
        payload
    });

    static returnInspectionError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_ERROR,
        payload
    });

    static returnInspectionReset = () => ({
        type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_RESET,
    });


    static changeCommentsDamages = (payload, evt) => ({
        type: INSPECTION_DETAIL_ACTIONS.CHANGE_COMMENT_DAMAGES,
        payload,
        evt
    });

    static changeCommentsPictures = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.CHANGE_COMMENT_PICTURES,
        payload
    });

    static saveCommentsDamages = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_DAMAGES,
        payload
    });

    static saveCommentsDamagesOk = (inspection) => ({
        type: INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_DAMAGES_OK,
        payload: {
            inspection
        }
    });

    static saveCommentsDamagesError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_DAMAGES_ERROR,
        payload
    });

    static saveCommentsPictures = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_PICTURES,
        payload
    });

    static saveCommentsPicturesOk = (inspection) => ({
        type: INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_PICTURES_OK,
        payload: {
            inspection
        }
    });

    static saveCommentsPicturesError = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_PICTURES_ERROR,
        payload
    });

    static validateButtonObservation = () => ({
        type: INSPECTION_DETAIL_ACTIONS.VALIDATE_BUTTON_OBSERVATION,
        payload: true
    });

    static validateButtonObservationOk = (payload) => ({
        type: INSPECTION_DETAIL_ACTIONS.VALIDATE_BUTTON_OBSERVATION_OK,
        payload
    });


    static addPictureObservation = (index, observation) => ({
        type: INSPECTION_DETAIL_ACTIONS.ADD_PICTURE_OBSERVATION,
        payload: {
            index,
            observation
        }
    });

    static removePictureObservation = (index) => ({
        type: INSPECTION_DETAIL_ACTIONS.REMOVE_PICTURE_OBSERVATION,
        payload: {
            index
        }
    });

    static addAccessoryObservation = (index, observation) => ({
        type: INSPECTION_DETAIL_ACTIONS.ADD_ACCESSORY_OBSERVATION,
        payload: {
            index,
            observation
        }
    });

    static removeAccessoryObservation = (index) => ({
        type: INSPECTION_DETAIL_ACTIONS.REMOVE_ACCESSORY_OBSERVATION,
        payload: {
            index
        }
    });

    static addDamageObservation = (index, observation) => ({
        type: INSPECTION_DETAIL_ACTIONS.ADD_DAMAGE_OBSERVATION,
        payload: {
            index,
            observation
        }
    });

    static removeDamageObservation = (index) => ({
        type: INSPECTION_DETAIL_ACTIONS.REMOVE_DAMAGE_OBSERVATION,
        payload: {
            index
        }
    })
    // static getReportInspection = () => ({
    // 	type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REPORT
    // })
    // static getReportInspectionOk = (payload) => ({
    //     type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REPORT_OK,
    // 	payload
    // })
    // static getReportInspectionError = (payload) => ({
    //     type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REPORT_ERROR,
    // 	payload
    // })
    // static getReportInspectionReset = () => ({
    //     type: INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REPORT_RESET,
    // })

}

export default InspectionDetailAction;



// WEBPACK FOOTER //
// ./src/redux/actions/inspection.js